import { Link } from "react-router-dom";

interface RegistryNoticeProps {
  items: string[];
}

export function RegistryNotice({ items }: RegistryNoticeProps) {
  return (
    <aside className="my-8 rounded-xl border border-amber-500/60 bg-amber-500/5 p-5">
      <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-amber-400">
        Additional data since publication
      </p>
      <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-relaxed text-foreground/85">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <Link
        to="/corrections"
        className="mt-4 inline-block text-sm font-semibold text-amber-400 hover:opacity-80"
      >
        See the Corrections Log
      </Link>
    </aside>
  );
}
